import React, { useCallback } from 'react';
import { Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import IconBackGround from '../iconBackGround';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { menuSectionStore } from '../../../store/menuSectionStore';
import { isMobile } from '../../../core/helpers/isMobile';

const CloseIcon = observer(({ x = 0, y = 0 }) => {
  const { setIsShowMenuPopup } = menuSectionStore;
  const { closeAmountListIcon } = getGameImages();
  const handleSelect = useCallback(() => {
    setIsShowMenuPopup(false);
  }, [setIsShowMenuPopup]);

  return (
    <IconBackGround y={y} x={x} handleSelect={handleSelect} hasSelectedState={false}>
      <Sprite texture={closeAmountListIcon} scale={isMobile() ? 0.77 : 0.5} anchor={0.5} />
    </IconBackGround>
  );
});
export default CloseIcon;
